export default {
  data() {
    return {
      total: 0,
      currentPage: 0,
      totalPage: 0,
      startPage: 0,
      endPage: 0,
      size: 10,
    };
  },
  mounted() {
    if (this.$route.query.size) this.size = this.$route.query.size;
  },
};
